export default "__VITE_ASSET__4314a388__"